export const RAIL_CONFIGURATOR_PRODUCT_CODE = "089750306000010";
export const TKDM_RAIL_CONFIGURATOR_PRODUCT_CODE = "301383081000010";
export const TKLT_RAIL_CONFIGURATOR_PRODUCT_CODE = "302691804000010";
export const CARRIAGE_CONFIGURATOR_PRODUCT_CODE = "089750462000010";
export const KWLT_CARRIAGE_CONFIGURATOR_PRODUCT_CODE = "302691812000010";
export const UNIT_CONFIGURATOR_PRODUCT_CODE = "089750276000010";
export const KLLT_UNIT_CONFIGURATOR_PRODUCT_CODE = "302553681000010";
export const METRIC_SHAFT_CONFIGURATOR_PRODUCT_CODE = "089647300000010";
export const INCH_SHAFT_CONFIGURATOR_PRODUCT_CODE = "093529856000010";

export const REFERENCE_MATERIAL_CSTIC = "VMWZ_999";
